
import axios from "axios";
import axiosInstance from "../../../Axios/Axios";

const GetAllActivePersonByTenantId=async({queryKey}:any)=>{
    let tenantId=queryKey[1]
    return await axiosInstance.get(`/Person/GetAllActivePersonByTenantId?tenantId=${tenantId}`)
}

const GetAllOKRStateByTenantId=async({queryKey}:any)=>{
    let tenantId=queryKey[1];
    return await axiosInstance.get(`/OKR/GetAllOKRStateByTenantId?tenantId=${tenantId}`)
}

const GetAllScoreLevelsByTenantId=async({queryKey}:any)=>{
    let tenantId=queryKey[1];
    return await axiosInstance.get(`/OKR/GetAllScoreLevelsByTenantId?tenantId=${tenantId}`)
}

const AddKeyResult=async(krData:any)=>{
return await axiosInstance.post('OKR/AddKeyResult',krData) 
}

const getAllObjectivePeriodsByTenantId=async()=>{
    return await axiosInstance.get('OKR/getAllPeriodsByTenantId?tenantId=3f2d72cf-cdff-413c-abcd-d5459d97890c')
}

const getAllObjectiveByPeriodId=async({queryKey}:any)=>{
    let periodId=queryKey[1];
    let profileTenantId=queryKey[2];
    return await axiosInstance.get(`/OKR/GetAllObjectiveByPeriodId/?tenantId=${profileTenantId}&periodId=${periodId}&pageIndex=1&pageSize=50000&searchTerm=`)
}

const getMyKeyResultByTenantId=async({queryKey}:any)=>{
    let periodId=queryKey[1];
    let profileTenantId=queryKey[2];
    return await axiosInstance.get(`/OKR/GetMyKeyResultByTenantId/?tenantId=${profileTenantId}&periodId=${periodId}&pageIndex=1&pageSize=50000&searchTerm=`)
}

const getAllKeyResultByTenantId=async({queryKey}:any)=>{
    let periodId=queryKey[1];
    let profileTenantId=queryKey[2];
    return await axiosInstance.get(`/OKR/GetAllKeyResultByTenantId/?tenantId=${profileTenantId}&periodId=${periodId}&pageIndex=1&pageSize=50000&searchTerm=`)
}


const getMyMeetingByTenantId=async({queryKey}:any)=>{
    let periodId=queryKey[1];
    let profileTenantId=queryKey[2];
    return await axiosInstance.get(`/OKR/GetMyMeetingByTenantId/?tenantId=${profileTenantId}&periodId=${periodId}&pageIndex=1&pageSize=50000&searchTerm=`)
}

const getDashBoardDataByTenantId=async({queryKey}:any)=>{
    let periodId=queryKey[1];
    let profileTenantId=queryKey[2];
    return await axiosInstance.get(`/OKR/GetDashBoardDataByTenantId/?tenantId=${profileTenantId}&periodId=${periodId}&pageIndex=1&pageSize=50000&searchTerm=`)
}

const getAllCooperateByPersonId=async({queryKey}:any)=>{
    let periodId=queryKey[1];
    let profileTenantId=queryKey[2];
    return await axiosInstance.get(`/OKR/GetAllCooperateByPersonId/?tenantId=${profileTenantId}&periodId=${periodId}`)
}

const getMyObjectiveByTenantId=async({queryKey}:any)=>{
    // profileTenantId
    let periodId=queryKey[1];
    let profileTenantId=queryKey[2];
    return await axiosInstance.get(`/OKR/GetMyObjectiveByTenantId/?tenantId=${profileTenantId}&periodId=${periodId}&pageIndex=1&pageSize=50000&searchTerm=`)
}

const getAllObjectiveByPersonId=async({queryKey}:any)=>{
    // profileTenantId
    let periodId=queryKey[1];
    let profileTenantId=queryKey[2];
    return await axiosInstance.get(`/OKR/WebGetAllObjectiveByPersonId/?periodId=${periodId}&pageIndex=1&pageSize=50000&searchTerm=`)
}

const getAllObjectiveDefinitionLevelByTenantId=async({queryKey}:any)=>{
    let tenantId:string|null=queryKey[1];
  return await axiosInstance.get(`OKR/getAllDefinitionLevelByTenantId?tenantId=${tenantId}`)
}

const GetAllObjectiveOKRStateByTenantId=async({queryKey}:any)=>{
    let tenantId:string|null=queryKey[1];
    return await axiosInstance.get(`OKR/GetAllOKRStateByTenantId?tenantId=${tenantId}`)
}

const getAllTeamAndPersonNameByTenantId=async({queryKey}:any)=>{
    let tenantId:string|null=queryKey[1];
    return await axiosInstance.get(`Team/WebGetAllTeamAndPersonNameByTenantId?tenantId=${tenantId}`)
}

const getAllCommentById=async({queryKey}:any)=>{
    let tenantId:string|null=queryKey[1];
    let meetingId:string|null=queryKey[2];
    return await axiosInstance.get(`Comment/GetCommentById?id=${tenantId}&meetingId=${meetingId}`)
}

const AddObjective=async(ObjectiveData:any)=>{
    return await axiosInstance.post(`OKR/AddObjective`,ObjectiveData)
  }

  const EditObjective=async(ObjectiveData:any)=>{
    return await axiosInstance.post(`OKR/EditObjective`,ObjectiveData)
  }

const getObjectiveDetails=async({queryKey}:any)=>{
    let objId:string|null=queryKey[1];
return await axiosInstance.get(`OKR/GetObjectiveDetailsById/?id=${objId}`)
}

const getKeyResultDetailsById=async({queryKey}:any)=>{
    let krId:string|null=queryKey[1];
return await axiosInstance.get(`OKR/GetKeyResultDetailsById/?id=${krId}`)
}


const getObjectiveDetailsById=async({queryKey}:any)=>{
    let obId:string|null=queryKey[1];
return await axiosInstance.get(`OKR/GetObjectiveDetailsById/?id=${obId}`)
}


const editKeyResult=async(krData:any)=>{
return await axiosInstance.post('OKR/EditKeyResult',krData)
}


const deleteKr=async(delteKrBody:any)=>{
    return await axiosInstance.post(`OKR/DeleteKeyResult`,delteKrBody)
}


const deleteObjective=async(delteKrBody:any)=>{
    return await axiosInstance.post(`OKR/DeleteObjective`,delteKrBody)
}

const addComment=async(delteKrBody:any)=>{
    return await axiosInstance.post(`Comment/AddComment`,delteKrBody)
}

const editComment=async(delteKrBody:any)=>{
    return await axiosInstance.post(`Comment/EditComment`,delteKrBody)
}

const deleteComment=async(delteKrBody:any)=>{
    return await axiosInstance.post(`Comment/DeleteComment`,delteKrBody)
}


export{
    GetAllActivePersonByTenantId,
    GetAllOKRStateByTenantId,
    GetAllScoreLevelsByTenantId,
    AddKeyResult,
    getAllObjectiveByPeriodId,
    getAllObjectiveByPersonId,
    getAllObjectiveDefinitionLevelByTenantId,
    GetAllObjectiveOKRStateByTenantId,
    AddObjective,
    getObjectiveDetails,
    getKeyResultDetailsById,
    editKeyResult,
    deleteKr,
    editComment,
    EditObjective,
    deleteObjective,
    getObjectiveDetailsById,
    getMyObjectiveByTenantId,
    getMyMeetingByTenantId,
    getMyKeyResultByTenantId,
    getDashBoardDataByTenantId,
    getAllCooperateByPersonId,
    getAllTeamAndPersonNameByTenantId,
    getAllKeyResultByTenantId,
    addComment,
    deleteComment,
    getAllCommentById
}